"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextArea = function TextArea(props) {
  var value = props.value,
      name = props.name,
      isInvalid = props.isInvalid,
      onChange = props.onChange,
      label = props.label,
      placeholder = props.placeholder,
      errors = props.errors,
      className = props.className,
      disabled = props.disabled,
      maxLength = props.maxLength,
      rows = props.rows,
      resize = props.resize;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "styleInput ".concat(className, " ").concat(resize ? '' : 'resize')
  }, label && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, label), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    as: "textarea",
    autoComplete: "off",
    placeholder: placeholder,
    value: value,
    name: name,
    isInvalid: isInvalid,
    onChange: onChange,
    className: "mb-3",
    disabled: disabled,
    maxLength: maxLength,
    rows: rows
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control.Feedback, {
    type: "invalid"
  }, errors));
};

TextArea.propTypes = {
  name: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  value: _propTypes.default.string,
  isInvalid: _propTypes.default.bool,
  errors: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  maxLength: _propTypes.default.number,
  rows: _propTypes.default.number,
  resize: _propTypes.default.bool
};
TextArea.defaultProps = {
  isInvalid: false,
  onChange: function onChange() {},
  value: '',
  errors: '',
  className: '',
  disabled: false,
  maxLength: Infinity,
  rows: 3,
  resize: true
};
var _default = TextArea;
exports.default = _default;